import { instanceOf, number, object, func, bool, string } from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { StoryGanttPopoverText } from '@opallabs/starchart'
import { actions } from '@opallabs/wormhole'
import loadBudget from './utils/loadBudget'

class StoryGanttPopoverComponent extends PureComponent {
  static propTypes = {
    budget: object,
    description: string,
    endDate: instanceOf(Date),
    getBudget: func,
    id: number,
    onBudgetLoad: func,
    shouldFetchBudget: bool,
    shouldShowBudget: bool,
    startDate: instanceOf(Date),
    title: string,
  }

  componentDidMount() {
    const { budget, getBudget, id, onBudgetLoad, shouldFetchBudget } =
      this.props

    if (shouldFetchBudget && !budget.id) {
      getBudget({ id, context: 'story' })
      onBudgetLoad()
    }

    return null
  }

  render() {
    return (
      <StoryGanttPopoverText {...this.props} budget={this.props.budget.value} />
    )
  }
}

const mapStateToProps = (state, props) => ({
  budget: loadBudget({ state, id: props.id, context: 'story' }),
})

const mapDispatchToProps = (dispatch) => ({
  getBudget: (options) => {
    dispatch(actions.getBudget(options))
  },
})

const ConnectedStoryGanttPopover = connect(
  mapStateToProps,
  mapDispatchToProps
)(StoryGanttPopoverComponent)

export default ConnectedStoryGanttPopover
